export const CREATE_NEW = 'createNew'
export const ADD_PUBLIC = 'addPublic'
export const RECOVER_WALLET = 'recoverWallet'
